export enum AssetClass {
  MobileMoney = 0,
  Crypto = 1,
}
